import { PureComponent, PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  clsNames: Array<string>;
}
export default class Page extends PureComponent<Props> {
  static defaultProps = {
    clsNames: [],
  };

  render() {
    const { clsNames, children } = this.props;

    const conClassNames = [...clsNames, "builder-page"];

    return <div className={conClassNames.join(" ")}>{children}</div>;
  }
}
